import { GetPostureReportResponse, ResultResult, RiskResult } from '../../../api/algorithm/posture/posture'

import jjtjmiddleleft from '../../../assets/posture/back/muscle_back_18.png'//肩胛提肌
import jjtjmiddleright from '../../../assets/posture/back/muscle_back_17.png'//肩胛提肌

import sxfjleft from '../../../assets/posture/back/muscle_back_3.png'//高侧斜方肌
import sxfjright from '../../../assets/posture/back/muscle_back_4.png'//高侧斜方肌

import xxfjleft from '../../../assets/posture/back/muscle_back_1.png'//高侧斜方肌
import xxfjright from '../../../assets/posture/back/muscle_back_2.png'//高侧斜方肌

import xfjleft from '../../../assets/posture/back/muscle_back_19.png'//高侧斜方肌
import xfjright from '../../../assets/posture/back/muscle_back_20.png'//高侧斜方肌

import tdjleft from '../../../assets/posture/back/muscle_back_8.png'//臀大肌
import tdjright from '../../../assets/posture/back/muscle_back_7.png'//臀大肌

import getjleft from '../../../assets/posture/back/muscle_back_13.png'//股二头肌
import getjright from '../../../assets/posture/back/muscle_back_14.png'//股二头肌

import bmyjleft from '../../../assets/posture/back/muscle_back_10.png'//比目鱼肌
import bmyjright from '../../../assets/posture/back/muscle_back_9.png'//比目鱼肌

import zdjmleft from '../../../assets/posture/back/muscle_back_16.png'//足底筋膜
import zdjmright from '../../../assets/posture/back/muscle_back_15.png'//足底筋膜

import xdjLeft from '../../../assets/posture/front/muscle_front_1.png'//胸大肌left
import xdjRight from '../../../assets/posture/front/muscle_front_2.png'//胸大肌right

import kwxj from '../../../assets/posture/front/muscle_front_11.png'//髋外旋肌

import klsjleft from '../../../assets/posture/front/muscle_front_6.png'//髋内收肌
import klsjright from '../../../assets/posture/front/muscle_front_5.png'//髋内收肌

import gstjtopleft from '../../../assets/posture/front/muscle_front_8.png'//股四头肌
import gstjtopright from '../../../assets/posture/front/muscle_front_7.png'//股四头肌

import gstjbottomleft from '../../../assets/posture/front/muscle_front_3.png'//股四头肌
import gstjbottomright from '../../../assets/posture/front/muscle_front_4.png'//股四头肌

import xsrtj from '../../../assets/posture/side/muscle_side_3.png'//胸锁乳突肌

import forwardheadMildLeft from '../../../assets/disease/forwardhead_mild_left.png'
import forwardheadMildRight from '../../../assets/disease/forwardhead_mild_right.png'
import forwardheadNormalLeft from '../../../assets/disease/forwardhead_normal_left.png'
import forwardheadNormalRight from '../../../assets/disease/forwardhead_normal_right.png'
import forwardheadSevereLeft from '../../../assets/disease/forwardhead_severe_left.png'
import forwardheadSevereRight from '../../../assets/disease/forwardhead_severe_right.png'
import kneehyperextensionMildLeft from '../../../assets/disease/kneehyperextension_mild_left.png'
import kneehyperextensionMildRight from '../../../assets/disease/kneehyperextension_mild_right.png'
import kneehyperextensionNormalLeft from '../../../assets/disease/kneehyperextension_normal_left.png'
import kneehyperextensionNormalRight from '../../../assets/disease/kneehyperextension_normal_right.png'
import kneehyperextensionSevereLeft from '../../../assets/disease/kneehyperextension_severe_left.png'
import kneehyperextensionSevereRight from '../../../assets/disease/kneehyperextension_severe_right.png'
import lateralheadMildLeft from '../../../assets/disease/lateralhead_mild_left.png'
import lateralheadMildRight from '../../../assets/disease/lateralhead_mild_right.png'
import lateralheadNormal from '../../../assets/disease/lateralhead_normal.png'
import lateralheadSevereLeft from '../../../assets/disease/lateralhead_severe_left.png'
import lateralheadSevereRight from '../../../assets/disease/lateralhead_severe_right.png'
import olegMildLeft from '../../../assets/disease/oleg_mild_left.png'
import olegMildRight from '../../../assets/disease/oleg_mild_right.png'
import olegNormalLeft from '../../../assets/disease/oleg_normal_left.png'
import olegNormalRight from '../../../assets/disease/oleg_normal_right.png'
import olegSevereLeft from '../../../assets/disease/oleg_severe_left.png'
import olegSevereRight from '../../../assets/disease/oleg_severe_right.png'
import roundedshoulderMildLeft from '../../../assets/disease/roundedshoulder_mild_left.png'
import roundedshoulderMildRight from '../../../assets/disease/roundedshoulder_mild_right.png'
import roundedshoulderNormalLeft from '../../../assets/disease/roundedshoulder_normal_left.png'
import roundedshoulderNormalRight from '../../../assets/disease/roundedshoulder_normal_right.png'
import roundedshoulderSevereLeft from '../../../assets/disease/roundedshoulder_severe_left.png'
import roundedshoulderSevereRight from '../../../assets/disease/roundedshoulder_severe_right.png'
import scoliosisMildLeft from '../../../assets/disease/scoliosis_mild_left.png'
import scoliosisMildRight from '../../../assets/disease/scoliosis_mild_right.png'
import scoliosisNormal from '../../../assets/disease/scoliosis_normal.png'
import scoliosisSevereLeft from '../../../assets/disease/scoliosis_severe_left.png'
import scoliosisSevereRight from '../../../assets/disease/scoliosis_severe_right.png'
import unevenhipMildLeft from '../../../assets/disease/unevenhip_mild_left.png'
import unevenhipMildRight from '../../../assets/disease/unevenhip_mild_right.png'
import unevenhipNormal from '../../../assets/disease/unevenhip_normal.png'
import unevenhipSevereLeft from '../../../assets/disease/unevenhip_severe_left.png'
import unevenhipSevereRight from '../../../assets/disease/unevenhip_severe_right.png'
import unevenshoulderMildLeft from '../../../assets/disease/unevenshoulder_mild_left.png'
import unevenshoulderMildRight from '../../../assets/disease/unevenshoulder_mild_right.png'
import unevenshoulderNormal from '../../../assets/disease/unevenshoulder_normal.png'
import unevenshoulderSevereLeft from '../../../assets/disease/unevenshoulder_severe_left.png'
import unevenshoulderSevereRight from '../../../assets/disease/unevenshoulder_severe_right.png'
import xlegMildLeft from '../../../assets/disease/xleg_mild_left.png'
import xlegMildRight from '../../../assets/disease/xleg_mild_right.png'
import xlegNormalLeft from '../../../assets/disease/xleg_normal_left.png'
import xlegNormalRight from '../../../assets/disease/xleg_normal_right.png'
import xlegSevereLeft from '../../../assets/disease/xleg_severe_left.png'
import xlegSevereRight from '../../../assets/disease/xleg_severe_right.png'
import xolegMildLeft from '../../../assets/disease/xoleg_mild_left.png'
import xolegMildRight from '../../../assets/disease/xoleg_mild_right.png'
import xolegNormalLeft from '../../../assets/disease/xoleg_normal_left.png'
import xolegNormalRight from '../../../assets/disease/xoleg_normal_right.png'
import xolegSevereLeft from '../../../assets/disease/xoleg_severe_left.png'
import xolegSevereRight from '../../../assets/disease/xoleg_severe_right.png'

export class RiskName {
    lateralhead: string = ''
    unevenshoulder: string = ''
    scoliosis: string = ''
    unevenhip: string = ''
    xleg: string = ''
    xoleg: string = ''
    oleg: string = ''
    forwardhead: string = ''
    roundedshoulder: string = ''
    kneehyperextension: string = ''
}
export type RiskNameEnum = keyof RiskName
export type RiskNameEnumArray = Array<keyof RiskName>
var boneDescription = {
    face: {
        trunk: "腹部肌群",
        legForX: ["髋外旋肌", "髋内收肌"],
        legForO: "髋外旋肌",
        legForStretch: "股四头肌",
        round: "胸大肌"
    },
    side: {
        round: "胸锁乳突肌",
        fore: "胸锁乳突肌",
        shoulder: "斜角肌"
    },
    back: {
        spine: "高侧斜方肌",
        shoulder: "高侧斜方肌",
        round: ["高侧斜方肌", "低侧斜方肌"],
        fore: ["高侧斜方肌", "低侧斜方肌"],
        rake: "肩胛提肌",
        legStretch: ["腘绳肌", "足底筋膜"],
        legX: ["髋外旋肌", "股二头肌"],
        legO: ["半腱肌半膜肌", "足内翻肌群"],
        legXO: ["股二头肌", "足底筋膜"]
    }
}
export class Icons {
    jjtj: string = '肩胛提肌';
    sxfj: string = '上斜方肌';
    xxfj: string = '下斜方肌';
    xfj: string = '斜方肌';
    tdj: string = '臀大肌';
    getj: string = '股二头肌';
    bmyj: string = '比目鱼肌';
    zdjm: string = '足底筋膜';
    xdj: string = '胸大肌';
    kwxj: string = '髋外旋肌';
    klsj: string = '髋内收肌';
    gstj: string = '股四头肌';
    jgqj: string = '胫骨前肌';
    xsrtj: string = '胸锁乳突肌';
}
export class IconsCondition {
    jjtj: RiskNameEnumArray = ["roundedshoulder", 'lateralhead', 'unevenshoulder']
    sxfj: RiskNameEnumArray = ['forwardhead']
    xxfj: RiskNameEnumArray = []
    xfj: RiskNameEnumArray = ['roundedshoulder']
    tdj: RiskNameEnumArray = ['unevenhip']
    getj: RiskNameEnumArray = ['unevenhip', 'xleg']
    bmyj: RiskNameEnumArray = ['scoliosis']
    zdjm: RiskNameEnumArray = ['kneehyperextension']
    xdj: RiskNameEnumArray = ['roundedshoulder']
    kwxj: RiskNameEnumArray = ['unevenshoulder', 'scoliosis', 'xleg', 'oleg']
    klsj: RiskNameEnumArray = ['unevenhip', 'xleg']
    gstj: RiskNameEnumArray = ['unevenshoulder', 'kneehyperextension', 'lateralhead']
    jgqj: RiskNameEnumArray = ['scoliosis']
    xsrtj: RiskNameEnumArray = ['forwardhead', 'roundedshoulder']

}
export type IconsEnum = keyof Icons


export type IconsEnumArray = Array<keyof Icons>

let iconTexts: Icons = {
    'jjtj': '肩胛提肌',
    'sxfj': '上斜方肌',
    'xxfj': '下斜方肌',
    'xfj': '斜方肌',
    'tdj': '臀大肌',
    'getj': '股二头肌',
    'bmyj': '比目鱼肌',
    'zdjm': '足底筋膜',
    'xdj': '胸大肌',
    'kwxj': '髋外旋肌',
    'klsj': '髋内收肌',
    'gstj': '股四头肌',
    'jgqj': '胫骨前肌',
    'xsrtj': '胸锁乳突肌',
}
export class Body {
    back: IconsEnumArray = ['jjtj', 'sxfj', 'xxfj', 'xfj', 'tdj', 'getj', 'bmyj', 'zdjm']
    front: IconsEnumArray = ['xdj', 'kwxj', 'klsj', 'gstj', ]
    side: IconsEnumArray = ['xsrtj']
}
export type LeftRightD = 'left' | 'right' | 'none'
export type PD = 'front' | 'side' | 'back'

export class IconsItem {
    key?: IconsEnum
    show?: boolean

    name?: string = ''
    levle: L = "normal"
    high?: Array<IconPoint>
    middle?: Array<IconPoint>
    normal?: Array<IconPoint>
    origin?: RiskResult
}

export interface IconPoint {
    url: string,
    direction: LeftRightD,
    scalex: number,
    scaley: number,
    offsetx: number,
    offsety: number,
}
export type Icon = {
    [K in keyof IconsItem]: IconsItem[K]
}
export type IconsEnumAndName = {
    [K in keyof Icons]: Icons[K]
}
export class IconsConf {
    'jjtj': IconsItem = {
        levle: "normal",
        show: false,
        key: "jjtj",
        high: [
            {
                url: jjtjmiddleleft,
                direction: "left",
                scalex: 0.1,
                scaley: 0.06,
                offsetx: 3.9,
                offsety: 1.6,
            },
            {
                url: jjtjmiddleright,
                direction: "right",
                scalex: 0.1,
                scaley: 0.06,
                offsetx: 5.1,
                offsety: 1.6,
            },
        ],
        middle:[
            {
                url: jjtjmiddleleft,
                direction: "left",
                scalex: 0.1,
                scaley: 0.06,
                offsetx: 3.9,
                offsety: 1.6,
            },
            {
                url: jjtjmiddleright,
                direction: "right",
                scalex: 0.1,
                scaley: 0.06,
                offsetx: 5.1,
                offsety: 1.6,
            }, 
        ],
    }
    'sxfj': IconsItem = {
        levle: "normal",
        show: false,
        key: "sxfj",
        high: [
            {
                url: sxfjleft,
                direction: "left",
                scalex: 0.21,
                scaley: 0.08,
                offsetx: 1.3,
                offsety: 1.9,
            },
            {
                url: sxfjright,
                direction: "right",
                scalex: 0.21,
                scaley: 0.08,
                offsetx: 2.5,
                offsety: 1.9,
            },
        ],
        middle: [
            {
                url: xxfjleft,
                direction: "left",
                scalex: 0.21,
                scaley: 0.08,
                offsetx: 1.3,
                offsety: 1.9,
            },
            {
                url: xxfjright,
                direction: "right",
                scalex: 0.21,
                scaley: 0.08,
                offsetx: 2.5,
                offsety: 1.9,
            },
        ]
    }
    'xxfj': IconsItem = {
        levle: "normal",
        show: false,
        key: "xxfj"
    }
    'xfj': IconsItem = {
        levle: "normal",
        show: false,
        key: "xfj",
        high: [
            {
                url: xfjleft,
                direction: "left",
                scalex: 0.21,
                scaley: 0.16,
                offsetx: 1.3,
                offsety: 1,
            },
            {
                url: xfjright,
                direction: "right",
                scalex: 0.21,
                scaley: 0.16,
                offsetx: 2.5,
                offsety: 1,
            },
        ],
        middle: [
            {
                url: xfjleft,
                direction: "left",
                scalex: 0.21,
                scaley: 0.16,
                offsetx: 1.3,
                offsety: 1,
            },
            {
                url: xfjright,
                direction: "right",
                scalex: 0.21,
                scaley: 0.16,
                offsetx: 2.5,
                offsety: 1,
            },
        ]
    }
    'tdj': IconsItem = {
        levle: "normal",
        show: false,
        key: "tdj",
        middle: [
            {
                url: tdjleft,
                direction: "left",
                scalex: 0.17,
                scaley: 0.08,
                offsetx: 1.8,
                offsety: 5.8,
            },
            {
                url: tdjright,
                direction: "right",
                scalex: 0.17,
                scaley: 0.08,
                offsetx: 3.1,
                offsety: 5.8,
            },
        ],
        high: [
            {
                url: tdjleft,
                direction: "left",
                scalex: 0.17,
                scaley: 0.08,
                offsetx: 1.8,
                offsety: 5.8,
            },
            {
                url: tdjright,
                direction: "right",
                scalex: 0.17,
                scaley: 0.08,
                offsetx: 3.1,
                offsety: 5.8,
            },
        ]
    }
    'getj': IconsItem = {
        levle: "normal",
        show: false,
        key: "getj",
        middle: [
            {
                url: getjleft,
                direction: "left",
                scalex: 0.12,
                scaley: 0.16,
                offsetx: 2.1,
                offsety: 3.5,
            },
            {
                url: getjright,
                direction: "right",
                scalex: 0.12,
                scaley: 0.16,
                offsetx: 5.2,
                offsety: 3.5,
            },
        ],
        high: [
            {
                url: getjleft,
                direction: "left",
                scalex: 0.12,
                scaley: 0.16,
                offsetx: 2.1,
                offsety: 3.5,
            },
            {
                url: getjright,
                direction: "right",
                scalex: 0.12,
                scaley: 0.16,
                offsetx: 5.2,
                offsety: 3.5,
            },
        ]
    }
    'bmyj': IconsItem = {
        levle: "normal",
        show: false,
        key: "bmyj",
        high: [
            {
                url: bmyjleft,
                direction: "left",
                scalex: 0.18,
                scaley: 0.12,
                offsetx: 1.2,
                offsety: 5.9,
            },
            {
                url: bmyjright,
                direction: "right",
                scalex: 0.18,
                scaley: 0.12,
                offsetx: 3.4,
                offsety: 5.9,
            },
        ],
        middle: [
            {
                url: bmyjleft,
                direction: "left",
                scalex: 0.18,
                scaley: 0.12,
                offsetx: 1.2,
                offsety: 5.9,
            },
            {
                url: bmyjright,
                direction: "right",
                scalex: 0.18,
                scaley: 0.12,
                offsetx: 3.4,
                offsety: 5.9,
            },
        ]
    }
    'zdjm': IconsItem = {
        levle: "normal",
        show: false,
        key: "zdjm",
        middle: [
            {
                url: zdjmleft,
                direction: "left",
                scalex: 0.14,
                scaley: 0.015,
                offsetx: 1.3,
                offsety: 64,
            },
            {
                url: zdjmright,
                direction: "right",
                scalex: 0.14,
                scaley: 0.015,
                offsetx: 4.8,
                offsety: 64,
            },
        ],
        high: [
            {
                url: zdjmleft,
                direction: "left",
                scalex: 0.14,
                scaley: 0.015,
                offsetx: 1.3,
                offsety: 64,
            },
            {
                url: zdjmright,
                direction: "right",
                scalex: 0.14,
                scaley: 0.015,
                offsetx: 4.8,
                offsety: 64,
            },
        ],
    }
    'xdj': IconsItem = {
        levle: "normal",
        show: false,
        key: "xdj",
        middle: [
            {
                url: xdjLeft,
                direction: "left",
                scalex: 0.25,
                scaley: 0.1,
                offsetx: 1,
                offsety: 1.8,
            },
            {
                url: xdjRight,
                direction: "right",
                scalex: 0.25,
                scaley: 0.1,
                offsetx: 2,
                offsety: 1.8,
            }
        ],
        normal:[
            {
                url: xdjLeft,
                direction: "left",
                scalex: 0.25,
                scaley: 0.1,
                offsetx: 1,
                offsety: 1.8,
            },
            {
                url: xdjRight,
                direction: "right",
                scalex: 0.25,
                scaley: 0.1,
                offsetx: 2,
                offsety: 1.8,
            }
        ],
        high: [
            {
                url: xdjLeft,
                direction: "left",
                scalex: 0.25,
                scaley: 0.1,
                offsetx: 1,
                offsety: 1.8,
            },
            {
                url: xdjRight,
                direction: "right",
                scalex: 0.25,
                scaley: 0.1,
                offsetx: 2,
                offsety: 1.8,
            }
        ],
    }
    'kwxj': IconsItem = {
        levle: "normal",
        show: false,
        key: "kwxj",
        high: [
            {
                url: kwxj,
                direction: "right",
                scalex: 0.26,
                scaley: 0.25,
                offsetx: 1.4,
                offsety: 1.1,
            }
        ],
        middle: [
            {
                url: kwxj,
                direction: "right",
                scalex: 0.26,
                scaley: 0.25,
                offsetx: 1.4,
                offsety: 1.1,
            }
        ],
    }
    'klsj': IconsItem = {
        levle: "normal",
        show: false,
        key: "klsj",
        high: [
            {
                url: klsjleft,
                direction: "right",
                scalex: 0.13,
                scaley: 0.2,
                offsetx: 2.7,
                offsety: 2.3,
            },
            {
                url: klsjright,
                direction: "right",
                scalex: 0.13,
                scaley: 0.2,
                offsetx: 3.9,
                offsety: 2.3,
            },
        ],
        middle: [
            {
                url: klsjleft,
                direction: "right",
                scalex: 0.13,
                scaley: 0.2,
                offsetx: 2.7,
                offsety: 2.3,
            },
            {
                url: klsjright,
                direction: "right",
                scalex: 0.13,
                scaley: 0.2,
                offsetx: 3.9,
                offsety: 2.3,
            },
        ],
    }
    'gstj': IconsItem = {
        levle: "normal",
        show: false,
        key: "gstj",
        middle: [
            {
                url: gstjtopleft,
                direction: "right",
                scalex: 0.1,
                scaley: 0.13,
                offsetx: 2.3,
                offsety: 3.3,
            },
            {
                url: gstjtopright,
                direction: "right",
                scalex: 0.1,
                scaley: 0.13,
                offsetx: 6.6,
                offsety: 3.3,
            },
            {
                url: gstjbottomleft,
                direction: "right",
                scalex: 0.16,
                scaley: 0.2,
                offsetx: 1.4,
                offsety: 2.3,
            },
            {
                url: gstjbottomright,
                direction: "right",
                scalex: 0.16,
                scaley: 0.2,
                offsetx: 3.8,
                offsety: 2.3,
            },
        ],
        high: [
            {
                url: gstjtopleft,
                direction: "right",
                scalex: 0.1,
                scaley: 0.13,
                offsetx: 2.3,
                offsety: 3.3,
            },
            {
                url: gstjtopright,
                direction: "right",
                scalex: 0.1,
                scaley: 0.13,
                offsetx: 6.6,
                offsety: 3.3,
            },
            {
                url: gstjbottomleft,
                direction: "right",
                scalex: 0.16,
                scaley: 0.2,
                offsetx: 1.4,
                offsety: 2.3,
            },
            {
                url: gstjbottomright,
                direction: "right",
                scalex: 0.16,
                scaley: 0.2,
                offsetx: 3.8,
                offsety: 2.3,
            },
        ]
    }
    'jgqj': IconsItem = {
        levle: "normal",
        show: false,
        key: "jgqj"
    }
    'xsrtj': IconsItem = {
        levle: "normal",
        show: false,
        key: "xsrtj",
        high: [
            {
                url: xsrtj,
                direction: "none",
                scalex: 0.13,
                scaley: 0.07,
                offsetx: 2.8,
                offsety: 1.6,
            },
        ],
        middle: [
            {
                url: xsrtj,
                direction: "none",
                scalex: 0.13,
                scaley: 0.07,
                offsetx: 2.8,
                offsety: 1.6,
            },
        ]
    }
}
type D = 'front' | 'side' | 'back'
type L = 'normal' | 'middle' | 'high'

export class EvaluteConf {
    lateralhead: IconsItem = {
        levle: "normal",
        show: false,
        key: "jjtj",
        middle: [
            {
                url: jjtjmiddleleft,
                direction: "left",
                scalex: 0.1,
                scaley: 0.06,
                offsetx: 3.9,
                offsety: 1.6,
            },
        ],
        high: [
            {
                url: jjtjmiddleleft,
                direction: "left",
                scalex: 0.1,
                scaley: 0.06,
                offsetx: 3.9,
                offsety: 1.6,
            },
        ],
        normal: [
            {
                url: jjtjmiddleleft,
                direction: "left",
                scalex: 0.1,
                scaley: 0.06,
                offsetx: 3.9,
                offsety: 1.6,
            },
        ]

    }
    unevenshoulder: IconsItem = {
        levle: "normal"
    }
    scoliosis: IconsItem = {
        levle: "normal"
    }
    unevenhip: IconsItem = {
        levle: "normal"
    }
    xleg: IconsItem = {
        levle: "normal"
    }
    xoleg: IconsItem = {
        levle: "normal"
    }
    oleg: IconsItem = {
        levle: "normal"
    }
    forwardhead: IconsItem = {
        levle: "normal"
    }
    roundedshoulder: IconsItem = {
        levle: "normal"
    }
    kneehyperextension: IconsItem = {
        levle: "normal"
    }
}

const riskImages = {
    "lateralhead": {
        "normal": {
            "": lateralheadNormal
        },
        "severe": {
            "left": lateralheadSevereLeft,
            "right": lateralheadSevereRight
        },
        "mild": {
            "left": lateralheadMildLeft,
            "right": lateralheadMildRight
        }
    },
    "unevenshoulder": {
        "normal": {
            "": unevenshoulderNormal
        },
        "mild": {
            "left": unevenshoulderMildLeft,
            "right": unevenshoulderMildRight
        },
        "severe": {
            "left": unevenshoulderSevereLeft,
            "right": unevenshoulderSevereRight
        }
    },
    "scoliosis": {
        "normal": {
            "": scoliosisNormal
        },
        "mild": {
            "left": scoliosisMildLeft,
            "right": scoliosisMildRight
        },
        "severe": {
            "left": scoliosisSevereLeft,
            "right": scoliosisSevereRight
        }
    },
    "unevenhip": {
        "normal": {
            "": unevenhipNormal
        },
        "mild": {
            "left": unevenhipMildLeft,
            "right": unevenhipMildRight
        },
        "severe": {
            "left": unevenhipSevereLeft,
            "right": unevenhipSevereRight
        }
    },
    "xleg": {
        "normal": {
            "left": xlegNormalLeft,
            "right": xlegNormalRight,
        },
        "mild": {
            "left": xlegMildLeft,
            "right": xlegMildRight
        },
        "severe": {
            "left": xlegSevereLeft,
            "right": xlegSevereRight
        }
    },
    "oleg": {
        "normal": {
            "left": olegNormalLeft,
            "right": olegNormalRight,
        },
        "mild": {
            "left": olegMildLeft,
            "right": olegMildRight
        },
        "severe": {
            "left": olegSevereLeft,
            "right": olegSevereRight
        }
    },
    "xoleg": {
        "normal": {
            "left": xolegNormalLeft,
            "right": xolegNormalRight,
        },
        "mild": {
            "left": xolegMildLeft,
            "right": xolegMildRight
        },
        "severe": {
            "left": xolegSevereLeft,
            "right": xolegSevereRight
        }
    },
    "forwardhead": {
        "normal": {
            "left": forwardheadNormalLeft,
            "right": forwardheadNormalRight,
        },
        "mild": {
            "left": forwardheadMildLeft,
            "right": forwardheadMildRight
        },
        "severe": {
            "left": forwardheadSevereLeft,
            "right": forwardheadSevereRight
        }
    },
    "roundedshoulder": {
        "normal": {
            "left": roundedshoulderNormalLeft,
            "right": roundedshoulderNormalRight,
        },
        "mild": {
            "left": roundedshoulderMildLeft,
            "right": roundedshoulderMildRight
        },
        "severe": {
            "left": roundedshoulderSevereLeft,
            "right": roundedshoulderSevereRight
        }
    },
    "kneehyperextension": {
        "normal": {
            "left": kneehyperextensionNormalLeft,
            "right": kneehyperextensionNormalRight,
        },
        "mild": {
            "left": kneehyperextensionMildLeft,
            "right": kneehyperextensionMildRight
        },
        "severe": {
            "left": kneehyperextensionSevereLeft,
            "right": kneehyperextensionSevereRight
        }
    },
}

export class MuscleData {
    risks: Array<RiskResult> = []
    originRisks: Array<RiskResult> = []
    iconTexts: Icons = new Icons();
    iconsCondition: IconsCondition = new IconsCondition();
    iconsConf: IconsConf = new IconsConf();
    body: Body = new Body();
    constructor(data: any) {


        let frontRisks = data.body?.front?.risks || []
        let sideRisks = data.body?.side?.risks || []
        sideRisks.forEach(risk => {
            risk.direction = (data.body?.side?.side ? data.body.side.side : "") as any
        })
        let backPoints = JSON.stringify(data.body?.back?.points || {});
        let backPointsJson = JSON.parse(backPoints)
        if (backPointsJson['heel']) {
            let leftHeelRisk = this.calculateRiskData(data.body.back, "heel", "ankle", "left", 11);
            let rightHeelRisk = this.calculateRiskData(data.body.back, "heel", "ankle", "right", 12);
            const leftX = data.body?.back?.points?.["ankle"]?.["left"]?.x;
            const leftHeelX = data.body?.back?.points?.["heel"]?.["left"]?.x;
            if (leftX && leftHeelX && leftX > leftHeelX) {
                leftHeelRisk.raw = -leftHeelRisk.raw;
            }
            const rightX = data.body?.back?.points?.["ankle"]?.["right"]?.x;
            const rightHeelX = data.body?.back?.points?.["heel"]?.["right"]?.x;
            if (rightX && rightHeelX && rightX < rightHeelX) {
                rightHeelRisk.raw = -rightHeelRisk.raw;
            }
            frontRisks.push(leftHeelRisk)
            frontRisks.push(rightHeelRisk)
        }
        let riskExist: Array<any> = []
        frontRisks.concat(sideRisks).map((rItem) => {

            let k = rItem.key as any
            if (!riskExist.includes(k)) {
                this.originRisks.push(rItem)
                this.risks.push(rItem)
            }
        })
        this.getMuscleData()
        this.getRiskData()
    }
    getRiskData = (): Array<RiskResult> => {
        let risks = JSON.parse(JSON.stringify(this.risks));
        risks.filter(item => item.valid).map((item) => {
            if (riskImages[item.key]) {
                item.D = riskImages[item.key][item.level][item.direction]
            }
        })
        return risks;
    }
    getMuscleData = () => {
        let risks = this.risks
        let iconsConf = this.iconsConf
        let iconsCondition = this.iconsCondition
        let severeRisk = risks.filter((item) => {
            return item.level == "severe"
        })
        let middleRisk = risks.filter((item) => {
            return item.level == "mild"
        })
        middleRisk.forEach((item) => {
            let key: RiskNameEnum = item.key as any;
            let level: L = 'normal';
            if (item.level == "severe") {
                level = "high"
            }
            if (item.level == "mild") {
                level = "middle"
            }
            let condition: IconsEnum;
            for (condition in iconsCondition) {
                const cArray = iconsCondition[condition];
                iconsConf[condition].name = this.iconTexts[condition]
                iconsConf[condition].origin = item;
                if (cArray.includes(key)) {
                    iconsConf[condition].show = true;
                    iconsConf[condition].levle = level
                } else {
                    iconsConf[condition].show = false;
                    iconsConf[condition].levle = "normal"
                }
            }
        })
        severeRisk.forEach((item) => {
            let key: RiskNameEnum = item.key as any;
            let level: L = 'normal';
            if (item.level == "severe") {
                level = "high"
            }
            if (item.level == "mild") {
                level = "middle"
            }
            let condition: IconsEnum;
            for (condition in iconsCondition) {
                iconsConf[condition].name = this.iconTexts[condition]
                iconsConf[condition].origin = item;
                const cArray = iconsCondition[condition];
                if (cArray.includes(key)) {
                    iconsConf[condition].show = true;
                    iconsConf[condition].levle = level
                } else {
                    iconsConf[condition].show = false;
                    iconsConf[condition].levle = "normal"
                }
            }
        })
        this.iconsConf = iconsConf
    }

    getData = (d: PD): Array<IconsItem> => {
        let iconsConf = this.iconsConf
        let data: Array<IconsItem> = []
        let c: IconsEnumArray = []
        if (d == "front") {
            c = this.body.front
            let condition: IconsEnum;
            for (condition in iconsConf) {
                if (c.includes(condition)) {
                    data.push(iconsConf[condition])
                }
            }
        }
        if (d == "side") {
            c = this.body.side
            let condition: IconsEnum;
            for (condition in iconsConf) {
                if (c.includes(condition)) {
                    data.push(iconsConf[condition])
                }
            }
        }
        if (d == "back") {
            c = this.body.back
            let condition: IconsEnum;
            for (condition in iconsConf) {
                if (c.includes(condition)) {
                    data.push(iconsConf[condition])
                }
            }
        }
        return data
    }
    riskObject = (id = 0) => {
        return {
            code: id,
            description: "",
            detail: "",
            direction: '',
            id: id,
            key: '',
            level: "",
            meanValue: 0,
            name: '',
            position: '',
            raw: 0,
            valid: true,
            value: 0
        }
    }
    calculateRiskData = (data: any, pointPosition1, pointPosition2, direction, id) => {
        let risk = this.riskObject(id)
        risk.direction = direction
        risk.key = pointPosition2+pointPosition1+direction
        risk.name = pointPosition2+pointPosition1+direction;
        risk.position = pointPosition2+pointPosition1;
        let line1 = {
            x1:data.points[pointPosition1][direction].x,
            y1:data.points[pointPosition1][direction].y,
            x2:data.points[pointPosition1][direction].x,
            y2:data.points[pointPosition2][direction].y
        }
        let line2 = {
            x1:data.points[pointPosition1][direction].x,
            y1:data.points[pointPosition1][direction].y,
            x2:data.points[pointPosition2][direction].x,
            y2:data.points[pointPosition2][direction].y
        }
        let heelAngle = this.calculateAngleBetweenLines(line1, line2);
        risk.raw = heelAngle
        return risk;
    }
    //计算两条线之间的夹角度数
    calculateAngleBetweenLines = (line1, line2) => {
        // 线1的向量
        const vec1 = {
            x: line1.x2 - line1.x1,
            y: line1.y2 - line1.y1
        };

        // 线2的向量
        const vec2 = {
            x: line2.x2 - line2.x1,
            y: line2.y2 - line2.y1
        };

        // 计算点积
        const dotProduct = vec1.x * vec2.x + vec1.y * vec2.y;

        // 计算向量长度
        const mag1 = Math.sqrt(vec1.x * vec1.x + vec1.y * vec1.y);
        const mag2 = Math.sqrt(vec2.x * vec2.x + vec2.y * vec2.y);

        // 计算夹角（弧度）
        const cosTheta = dotProduct / (mag1 * mag2);
        const angleRad = Math.acos(Math.min(Math.max(cosTheta, -1), 1)); // 确保值在[-1,1]范围内

        // 转换为度数
        const angleDeg = angleRad * (180 / Math.PI);

        return angleDeg;
    };
}

